<template>
  <div class="stop-resume-chat text-center">
    <v-btn
      @click="changeStatus(false)"
      :disabled="
        !this.$store.state.chatHistory.sessionBotStatus ||
        this.selectedSession.channel.slug !== 'whatsapp'
      "
      color="#292828"
      style="width: 125px"
      width="200"
      >Stop Bot
    </v-btn>
    <v-btn
      @click="changeStatus(true)"
      id="resume-chat"
      style="width: 125px"
      :disabled="this.$store.state.chatHistory.sessionBotStatus"
      color="primary"
      >Resume Bot
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "stopChat",
  props: {
    selectedSession: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      botStatus: true,
    };
  },
  methods: {
    async getStatus() {
      const response = await this.$http_session_manager.get(
        `/bots/${this.$store.state.bot.botId}/reply/${this.selectedSession.gateway_session_id}/status/`
      );

      this.$store.dispatch(
        "setSessionBotStatus",
        response.data.is_bot_reply_on
      );
    },
    async changeStatus(status) {
      this.$store.dispatch("setLoader", true);
      await this.$http_session_manager.put("/bots/enable/reply", {
        bot_id: this.$store.state.bot.botId,
        is_bot_reply_on: status,
        gateway_session_id: this.selectedSession.gateway_session_id,
      });

      this.$store.dispatch("setSessionBotStatus", status);
      this.$store.dispatch("setLoader", false);
    },
  },
  computed: {
    selectedSessionId() {
      return this.selectedSession._id;
    },
  },
  watch: {
    async selectedSessionId() {
      await this.getStatus();
    },
  },
};
</script>

<style lang="scss">
.stop-resume-chat {
  padding: 20px 0;
  border-bottom: 2px solid #eeeeee;
  .v-btn__content {
    color: white !important;
  }
}
</style>
